import React from 'react'
import LineChartGraph from './LineChartGraph'
function Compare() {
  return (
    <>
    <LineChartGraph/>
    </>
  )
}

export default Compare